import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/loader'
import SearchList from 'components/search-list'
import Table from 'components/table/table'
import NameColumn from 'components/table/name-column'
import TextColumn from 'components/table/text-column'
import { currencyFormat, formateDate } from 'utils'
import { ordersApi } from '../restaurant.api'

// There is no dedicated restaurant customers collection; customers are derived
// from their orders (grouped by phone number).
function aggregateCustomers(orders) {
  const map = new Map()
  for (const order of orders) {
    const info = order.customerInfo || {}
    const key = info.phone || info.email || order._id
    const existing = map.get(key) || {
      name: info.name || '—',
      phone: info.phone || '',
      email: info.email || '',
      totalOrders: 0,
      totalSpending: 0,
      lastOrder: null,
    }
    existing.totalOrders += 1
    existing.totalSpending += order.totalAmount || 0
    const created = order.createdAt ? new Date(order.createdAt) : null
    if (created && (!existing.lastOrder || created > existing.lastOrder)) {
      existing.lastOrder = created
      if (info.name) existing.name = info.name
    }
    map.set(key, existing)
  }
  return Array.from(map.values()).sort(
    (a, b) => b.totalSpending - a.totalSpending
  )
}

function CustomersInner() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [orders, setOrders] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    ;(async () => {
      const { response } = await ordersApi.list({ limit: 1000 })
      if (response) setOrders(response.data || [])
      setLoading(false)
    })()
  }, [])

  const customers = useMemo(() => aggregateCustomers(orders), [orders])

  const filtered = customers.filter((c) => {
    if (!search) return true
    const q = search.toLowerCase()
    return (
      c.name.toLowerCase().includes(q) ||
      c.phone.toLowerCase().includes(q) ||
      c.email.toLowerCase().includes(q)
    )
  })

  const headers = ['Name', 'Phone', 'Email', 'Orders', 'Spent', 'Last order']
  const rows = filtered.map((c) => ({
    Name: <NameColumn name={c.name} />,
    Phone: <TextColumn text={c.phone} />,
    Email: <TextColumn text={c.email} />,
    Orders: <TextColumn text={String(c.totalOrders)} />,
    Spent: <TextColumn text={currencyFormat(c.totalSpending)} />,
    'Last order': (
      <TextColumn text={c.lastOrder ? formateDate(c.lastOrder) : '—'} />
    ),
  }))

  return (
    <div>
      <div className='tw-mb-4'>
        <button
          onClick={() => navigate('/order-management')}
          className='tw-text-[12px] tw-text-gray-400'
        >
          ← Order management
        </button>
        <h2 className='font-heading tw-text-2xl'>Customers</h2>
        <p className='tw-text-xs tw-text-gray-400'>
          Derived from placed orders
        </p>
      </div>

      <div className='tw-mb-6 tw-flex'>
        <SearchList search={(e) => setSearch(e.target.value)} />
      </div>

      {loading ? (
        <Loader />
      ) : filtered.length ? (
        <Table headers={headers} data={rows} />
      ) : (
        <div className='tw-text-center tw-text-gray-400 tw-py-16'>
          No customers yet
        </div>
      )}
    </div>
  )
}

export default CustomersInner
